module.exports = __webpack_public_path__ + "static/media/promo.7108c863.svg";